var map = {
	"./AddIcon.svg": 35971,
	"./_download.svg": 57894,
	"./_edit (2).svg": 55749,
	"./_edit.svg": 59506,
	"./_email.svg": 92674,
	"./_filter.svg": 73044,
	"./_group.svg": 94567,
	"./_phase.svg": 74267,
	"./_print.svg": 57847,
	"./_trials_list.svg": 44336,
	"./_trials_map.svg": 39322,
	"./_type.svg": 58038,
	"./academic_cancer_logo.svg": 13601,
	"./actions/add_doctor.svg": 76498,
	"./actions/connect_with_oncologist.svg": 60674,
	"./actions/consult_with_us.svg": 39787,
	"./actions/ebook.svg": 84087,
	"./actions/edit_email.svg": 52858,
	"./actions/general.svg": 18833,
	"./actions/missing_data.svg": 38360,
	"./actions/next_appointment.svg": 41246,
	"./actions/next_scan.svg": 37824,
	"./actions/phone_login.svg": 17375,
	"./actions/search_doctor.svg": 36023,
	"./actions/see_all_options.svg": 35907,
	"./actions/send_to_doctor.svg": 3063,
	"./actions/share_with_doctor.svg": 57895,
	"./actions/treatment_experience.svg": 35192,
	"./actions/user_intent.svg": 49263,
	"./add_round.svg": 30585,
	"./aditional_info.svg": 81731,
	"./ai.svg": 42185,
	"./ai_discovery.svg": 54450,
	"./analyze.svg": 55373,
	"./arrow-circle-black.svg": 82301,
	"./arrow-circle-right.svg": 83698,
	"./arrow-circle-right_v2.svg": 2973,
	"./arrow-circle.svg": 14627,
	"./arrow-down.svg": 31759,
	"./arrow.svg": 57190,
	"./arrow_back.svg": 62312,
	"./arrow_down.svg": 33337,
	"./arrow_drop_down.svg": 42773,
	"./arrow_drop_up.svg": 74170,
	"./arrow_left.svg": 78946,
	"./arrow_left_2.svg": 66441,
	"./attention_icon.svg": 12153,
	"./back.svg": 79082,
	"./backward.svg": 79952,
	"./bell.svg": 73516,
	"./biomarker_tag.svg": 99072,
	"./book_round.svg": 52877,
	"./bullet.svg": 91127,
	"./burger_menu.svg": 50722,
	"./call_icon.svg": 63049,
	"./capsule.svg": 84088,
	"./cell.svg": 76435,
	"./chat.svg": 98701,
	"./chat_bubbles.svg": 29621,
	"./chat_icon.svg": 98715,
	"./check.svg": 82497,
	"./check_green.svg": 8205,
	"./check_orange.svg": 69482,
	"./checkbox.svg": 40548,
	"./checkbox1.svg": 88093,
	"./checked_Icon.svg": 34946,
	"./checkmark.svg": 95058,
	"./circle_add.svg": 21991,
	"./circle_subtract.svg": 21494,
	"./clock.svg": 92075,
	"./close.svg": 35837,
	"./close_2.svg": 62562,
	"./close_menu.svg": 83557,
	"./consult_icon.svg": 6151,
	"./cycle.svg": 29135,
	"./datepicker.svg": 8341,
	"./delete_icon.svg": 14582,
	"./delete_x.svg": 131,
	"./dot.svg": 18860,
	"./dots.svg": 48999,
	"./down_arrow.svg": 57573,
	"./download-pdf.svg": 98282,
	"./download.svg": 91303,
	"./drug.svg": 63953,
	"./drugs_black.svg": 60220,
	"./edit.svg": 975,
	"./edit_2.svg": 24740,
	"./edit_green.svg": 77219,
	"./edit_orange.svg": 33144,
	"./edit_treatment.svg": 8322,
	"./email.svg": 11089,
	"./email_round.svg": 66452,
	"./email_share.svg": 7341,
	"./emojis/bad.svg": 92770,
	"./emojis/happy.svg": 63993,
	"./emojis/sad.svg": 39791,
	"./empty_item.svg": 61480,
	"./expand.svg": 80863,
	"./fallback_image.svg": 95207,
	"./file.svg": 34709,
	"./filter.svg": 87985,
	"./fluent_pulse.svg": 13123,
	"./forward.svg": 51626,
	"./gear.svg": 47046,
	"./get_trial_location.svg": 57586,
	"./glass-white.svg": 83249,
	"./green_arrow.svg": 95850,
	"./group.svg": 7544,
	"./hand.svg": 83708,
	"./heart.svg": 49733,
	"./help.svg": 95330,
	"./hospital.svg": 51653,
	"./house.svg": 58901,
	"./important.svg": 51483,
	"./infinity_loader.svg": 71827,
	"./info.svg": 36947,
	"./info_icon.svg": 29581,
	"./intake_icon.svg": 17085,
	"./keyboard_arrow_right.svg": 24205,
	"./keyboard_double_arrow_right.svg": 97021,
	"./knobs.svg": 71110,
	"./last_treatment.svg": 55554,
	"./leal_logo_2.svg": 53150,
	"./leal_logo_round.svg": 42644,
	"./leal_logo_round_small.svg": 39816,
	"./left-align.svg": 98424,
	"./left.svg": 77644,
	"./left_arrow.svg": 28622,
	"./light_bulb.svg": 46929,
	"./link.svg": 31119,
	"./list.svg": 60071,
	"./location.svg": 84310,
	"./locationPin.svg": 15899,
	"./login-button.svg": 51279,
	"./mag-icon.svg": 65802,
	"./maki_doctor.svg": 43553,
	"./map.svg": 59543,
	"./map2.svg": 22679,
	"./maps.svg": 80006,
	"./mdi_heart.svg": 59936,
	"./menu_board.svg": 86555,
	"./message-text.svg": 42520,
	"./message_chat.svg": 36585,
	"./message_text.svg": 83418,
	"./minus.svg": 48441,
	"./more-circle.svg": 95745,
	"./nav_item_arrow.svg": 21470,
	"./new.svg": 33863,
	"./next.svg": 72396,
	"./note.svg": 59667,
	"./notebook.svg": 40124,
	"./notification.svg": 30566,
	"./overlay-x.svg": 37854,
	"./patients.svg": 30209,
	"./people.svg": 57014,
	"./phase.svg": 31444,
	"./phase_1.svg": 57824,
	"./phase_2.svg": 12371,
	"./phase_3.svg": 49730,
	"./phase_4.svg": 24397,
	"./phone.svg": 16345,
	"./pill.svg": 35498,
	"./play.svg": 10757,
	"./plus.svg": 24491,
	"./previous_treatments.svg": 53884,
	"./print.svg": 64684,
	"./profile.svg": 22030,
	"./profile_icon.svg": 82578,
	"./profile_results.svg": 42933,
	"./property.svg": 51804,
	"./publication.svg": 87043,
	"./record_icon.svg": 99784,
	"./refresh.svg": 32304,
	"./right.svg": 42387,
	"./right_arrow.svg": 33581,
	"./round_question.svg": 14700,
	"./scan_date.svg": 15839,
	"./schedule_a_call.svg": 97103,
	"./search-status.svg": 39022,
	"./search-zoom-in-black.svg": 23777,
	"./search-zoom-in-selector.svg": 50655,
	"./search-zoom-in.svg": 41687,
	"./search.svg": 64343,
	"./search_big.svg": 57192,
	"./search_clinical_trial.svg": 22200,
	"./search_rounded.svg": 51341,
	"./search_standard_treatment.svg": 88332,
	"./search_text.svg": 7759,
	"./send_message.svg": 1121,
	"./send_message_2.svg": 30382,
	"./sentiment_neutral.svg": 50286,
	"./sentiment_neutral_v2.svg": 98865,
	"./sentiment_satisfied.svg": 72315,
	"./sentiment_satisfied_v2.svg": 43678,
	"./sentiment_very_dissatisfied.svg": 15536,
	"./sentiment_very_dissatisfied_v2.svg": 13651,
	"./share.svg": 67300,
	"./share_with_doctor.svg": 81963,
	"./sort.svg": 12871,
	"./star.svg": 40815,
	"./status.svg": 44417,
	"./status_2.svg": 66478,
	"./success.svg": 50052,
	"./support.svg": 96212,
	"./support_white.svg": 97166,
	"./survey_popup.svg": 71922,
	"./thumb_down.svg": 42156,
	"./thumb_up.svg": 89639,
	"./tick-off.svg": 24028,
	"./tick-on.svg": 95814,
	"./tina.svg": 18205,
	"./tooltip_lamp.svg": 6989,
	"./trash.svg": 36891,
	"./trash_orange.svg": 82532,
	"./treatment.svg": 81941,
	"./treatment_icon.svg": 78707,
	"./treatments/chemo.svg": 21647,
	"./treatments/combo.svg": 46799,
	"./treatments/immuno.svg": 17458,
	"./treatments/radiation.svg": 4644,
	"./treatments/targeted.svg": 7975,
	"./trials_list.svg": 99199,
	"./trials_map.svg": 33871,
	"./type.svg": 47203,
	"./update_profile.svg": 82962,
	"./upload-files.svg": 33794,
	"./upload.svg": 50600,
	"./upload_document.svg": 90468,
	"./upload_white.svg": 44338,
	"./user.svg": 10698,
	"./user2.svg": 24852,
	"./user3.svg": 69781,
	"./userIcon.svg": 36457,
	"./userIconRedDot.svg": 27131,
	"./userLocationPin.svg": 41812,
	"./user_button.svg": 12041,
	"./user_role_chat.svg": 64842,
	"./user_tick.svg": 58678,
	"./v.svg": 3151,
	"./visibility.svg": 89187,
	"./visibility_off.svg": 22125,
	"./wallet.svg": 56736,
	"./watch.svg": 63708,
	"./what.svg": 22617,
	"./x.svg": 99897,
	"./x_orange.svg": 43714
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46669;